import { Injectable } from '@angular/core';
import { AppModule } from 'src/app/app.module';
import { SharedModule } from 'src/app/_components/shared.module';
import { ENVIRONMENT } from 'src/app/_constants/app.constants';
import { ServiceModule } from 'src/app/_services/service.module';

@Injectable({
  providedIn: ServiceModule,
})
export class LoggerService {

  constructor(
  ) {
  }

  /**
   *  debug
   *
   *  @param message
   *  @param optionalParams
   */
  debug(message?: any, ...optionalParams: any[]): void {
    if (ENVIRONMENT.PROPERTIES.logging.level !== 1) return
    console.debug(message, ...optionalParams);
  }

  /**
   *  trace
   *
   *  @param message
   *  @param optionalParams
   */
   trace(message?: any, ...optionalParams: any[]): void {
    if (ENVIRONMENT.PROPERTIES.logging.level !== 1) return
    console.trace(message, ...optionalParams);
  }

  /**
   *  info
   *
   *  @param message
   *  @param optionalParams
   */
   info(message?: any, ...optionalParams: any[]): void {
    if (ENVIRONMENT.PROPERTIES.logging.level !== 1) return
    console.info(message, ...optionalParams);
  }

  /**
   *  log
   *
   *  @param message
   *  @param optionalParams
   */
   log(message?: any, ...optionalParams: any[]): void {
    if (ENVIRONMENT.PROPERTIES.logging.level !== 1) return
    console.log(message, ...optionalParams);
  }

  /**
   *  warn
   *
   *  @param message
   *  @param optionalParams
   */
   warn(message?: any, ...optionalParams: any[]): void {
    if (ENVIRONMENT.PROPERTIES.logging.level !== 1) return
    console.warn(message, ...optionalParams);
  }

  /**
   *  error
   *
   *  @param message
   *  @param optionalParams
   */
   error(message?: any, ...optionalParams: any[]): void {
    if (ENVIRONMENT.PROPERTIES.logging.level !== 1) return
    console.error(message, ...optionalParams);
  }

  /**
   *  fatal
   *
   *  @param message
   *  @param optionalParams
   */
   fatal(message?: any, ...optionalParams: any[]): void {
    if (ENVIRONMENT.PROPERTIES.logging.level !== 1) return
    console.error(message, ...optionalParams);
  }

}
